import React from 'react';
import { useShipmentContext } from '../../../components/ShipmentProvider';
import LogsGrid from '@afosto/app-components-react/LogsGrid';

const ShipmentLogs = () => {
  const { shipment } = useShipmentContext();

  return (
    <LogsGrid
      fixedFilters={[
        {
          key: 'resource.entity_type',
          operator: 'in',
          value: ['shipment'],
        },
        {
          key: 'resource.entity_id',
          operator: 'in',
          value: [shipment?.id],
        },
      ]}
    />
  );
};

export default ShipmentLogs;
